import { Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useBabyStation } from "src/modules/baby-station/BabyStation/Context";
import { Tasks } from "src/modules/scheduler/Tasks";
import Connected from "./Connected";
import Waiting from "./Waiting";

export default function MonitoringStatus({
  monitoringStartTime,
  isMonitoring,
  isConnected,
  scheduler,
  ...rest
}) {
  const { t } = useTranslation();
  const babyStation = useBabyStation();
  const isEnabled = scheduler?.isEnabled;

  const activeScheduledMonitoring =
    isMonitoring &&
    isEnabled &&
    scheduler?.getActiveTasksByType(Tasks.scheduled_monitoring)[0];

  const scheduledMonitoring = isEnabled && scheduler?.getNextTask();
  return (
    <Box {...rest}>
      {isConnected || activeScheduledMonitoring ? (
        <Connected
          activeScheduledMonitoring={activeScheduledMonitoring}
          parents={babyStation.parents}
          monitoringStartTime={monitoringStartTime}
          t={t}
        />
      ) : (
        <Waiting
          t={t}
          scheduledMonitoring={scheduledMonitoring}
          scheduler={isEnabled ? scheduler : undefined}
        />
      )}
    </Box>
  );
}
